import React from "react";
import { Helmet } from "react-helmet";

import Layout from "../../components/Layout";
import InfoFooter from "../../components/InfoFooter";
import { SHOP } from "../../config";

import heroImage from "../../img/glasses-in-shop2.jpg";
import quotes from "../../img/quotes.svg";
import sarkaImage from "../../img/person-review4.jpg";
import pavelImage from "../../img/person-review.jpg";
import michalImage from "../../img/person-review2.jpg";
import jarmilaImage from "../../img/person-review3.jpg";
import facebookIcon from "../../img/facebook-icon2.svg";
import googleIcon from "../../img/google-icon.svg";

const GOOGLE_REVIEWS_URL =
  "https://www.google.com/maps/place/O%C4%8Dn%C3%AD+Optika+-+RNDr.+Josef+Bezd%C4%9Bka/@49.1657303,13.8849898,19.5z/data=!4m15!1m7!3m6!1s0x4774b55b04136e87:0xd8c703c7054fb07a!2s387+01+Volyn%C4%9B!3b1!8m2!3d49.1657857!4d13.886239!3m6!1s0x4774b55b6b3ddb8b:0x4b415b6c6d54e069!8m2!3d49.1658724!4d13.8851804!9m1!1b1";

const mapyUrl = `https://mapy.com/cs/?source=firm&id=${SHOP.mapyBadgeId}&firmBadge=1`;
const mapyBadge = `https://mapy.com/firm-badge.svg?id=${SHOP.mapyBadgeId}&source=firm`;

// side: which way the speech bubble points, matching the original layout.
const reviews = [
  {
    name: "Šárka",
    image: sarkaImage,
    alt: "referentka Šárka",
    side: "left",
    text: "Naprosto parádní servis! Díky paní Hronkové mám krásné nové sluneční brýle a nemůžu si je vynachválit. Přistupují k vám zde individuálně, takže vždy odcházíte přesně s tím, co vám nejvíc sedne. Určitě doporučuji 😉",
  },
  {
    name: "Pavel",
    image: pavelImage,
    alt: "referent Pavel",
    side: "right",
    text: "Do optiky chodíme pravidelně i s dětmi. Díky trpělivosti a zároveň odbornosti personálu totiž vždy dostaneme to nejlepší. Vůbec nepochybuji o tom, že budeme optiku dále navštěvovat. Určitě se také přijďte sami přesvědčit!",
  },
  {
    name: "Michal",
    image: michalImage,
    alt: "referent Michal",
    side: "left",
    text: "Jsem moc rád, že jsem si pro koupi nových tmavých dioptrických brýlí vybral právě optiku Volyně. Všechno tu jde totiž velmi rychle - změří vám zrak a ihned vám poradí s nákupem brýlí. Díky velké nabídce brýlí nebyl výběr problém. S brýlemi jsem moc spokojen a mohu optiku jedině doporučit.",
  },
  {
    name: "Jarmila",
    image: jarmilaImage,
    alt: "referentka Jarmila",
    side: "right",
    text: "Optiku Volyně navštěvujeme celá rodina už několik let a vždy jsme byli spokojení. Seženeme tady totiž brýle sluneční, dioptrické, na čtení i na dálku a vybereme si tak úplně všichni. Díky příjemné obsluze se vždy těšíme na další návštěvu 😀",
  },
];

const Reference = () => (
  <Layout>
    <Helmet
      title="Reference | Optika Volyně"
      meta={[
        {
          name: "description",
          content: "Reference a recenze zákazníků Optiky Volyně",
        },
        { name: "keywords", content: "Optika, Optometrie, Volyně, Reference" },
      ]}
    />
    <main className="references-main">
      <div className="slider-products">
        <img
          className="sliderphoto-products"
          width={1920}
          alt="foto brýlí v prodejně"
          src={heroImage}
        />
        <div className="slider-sale-and-text-products references-heading-container">
          <h1 className="slider-sale-products references-heading">
            Napsali o nás...
          </h1>
        </div>
        <img src={quotes} alt="uvozovky" className="quotes" />
      </div>

      <a
        className="mapy-reviews"
        target="_blank"
        rel="noreferrer"
        href={mapyUrl}
      >
        <img src={mapyBadge} alt="Hodnocení na Mapy.cz" />
      </a>

      <div className="review-grid">
        {reviews.map((review) => (
          <figure className="review-card" key={review.name}>
            <blockquote className="review-quote">{review.text}</blockquote>
            <figcaption className="review-author">
              <img
                className="review-avatar"
                src={review.image}
                alt={review.alt}
                loading="lazy"
              />
              <span className="review-name">{review.name}</span>
            </figcaption>
          </figure>
        ))}
      </div>

      <div className="make-review-section">
        <section>
          <h2>Podělte se také o svou zkušenost</h2>
          <p>
            Pomozte nám rozšířit pozitivní zážitky z návštěvy naší optiky. Pokud
            jste u nás byli spokojení, můžete o tom dát vědět i ostatním lidem
            pomocí hodnocení na Facebooku nebo recenze na Google. Budeme moc
            rádi za zpětnou vazbu a především se těšíme na vaši další návštěvu!
          </p>
        </section>
        <div className="reviewing">
          <a target="_blank" rel="noreferrer" href={mapyUrl}>
            <img
              className="mapy-image"
              src={mapyBadge}
              alt="Hodnocení na Mapy.cz"
            />
          </a>
          <div className="ways-of-reviewing">
            <a
              href={`${SHOP.facebook}reviews/?ref=page_internal`}
              target="_blank"
              rel="noreferrer"
            >
              <img
                src={facebookIcon}
                alt="odkazová ikona Facebooku směřující na hodnocení"
                width={100}
              />
            </a>
            <a href={GOOGLE_REVIEWS_URL} target="_blank" rel="noreferrer">
              <img
                src={googleIcon}
                alt="odkazová ikona Google směřující na recenze"
                width={100}
              />
            </a>
          </div>
        </div>
      </div>

      <InfoFooter />
    </main>
  </Layout>
);

export default Reference;
